export const APP_NAME = 'COMETRIX'
export const PERSIST_STORE_NAME = 'admin'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const TIMEZONE = -3
